import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[click-to-copy]',
  host: { '(click)': 'copyToClipboard($event)' }
})
export class ClickToCopyDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}
  ngAfterViewInit() {}
  copyToClipboard(event) {
    console.log(this.el.nativeElement);
    this.el.nativeElement;
    document.execCommand('copy');
    // if (this.el.nativeElement.className.indexOf("makeCall") >= 0) {
    //     return;
    // }
    // if (this.href.length === 0 || this.href === '#') {
    //     event.preventDefault();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/click-to-copy.directive.ts